import { render } from "./B2bPageGenralsEmits.vue?vue&type=template&id=38b6bb46&scoped=true&lang=pug"
import script from "./B2bPageGenralsEmits.vue?vue&type=script&lang=js"
export * from "./B2bPageGenralsEmits.vue?vue&type=script&lang=js"

import "./B2bPageGenralsEmits.vue?vue&type=style&index=0&id=38b6bb46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b6bb46"]])

export default __exports__